import React from 'react';
import Card from '../cards/Card';

function CenterPiles({ discardPile, deckRemaining, onDrawStock, onDrawDiscard, onDiscard, canDraw, canDiscard }) {
  const rugStyle = {
    backgroundImage: `url(${process.env.PUBLIC_URL}/rug.png)`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center center',
    backgroundSize: 'contain',
  };

  return (
    <div className="center-piles" style={rugStyle}>
      <div className="center-piles__pile" onClick={canDraw ? onDrawStock : undefined}>
        <Card
          card={null}
          faceUp={false}
          disabled={!canDraw}
        />
        <span className="center-piles__label">Stock ({deckRemaining})</span>
      </div>

      <div
        className="center-piles__pile"
        onClick={canDraw ? onDrawDiscard : (canDiscard ? onDiscard : undefined)}
      >
        <Card
          card={discardPile.topCard}
          faceUp={!!discardPile.topCard}
          disabled={!canDraw && !canDiscard}
        />
        <span className="center-piles__label">Discard</span>
      </div>
    </div>
  );
}

export default CenterPiles;
